module.exports = __webpack_public_path__ + "img/title.796a2580.png";